import request from './request';

export default {
	async getSummary(query) {
		const response = await request.get('/app/dashboard/summary', query);
		return response;
	},
	async getOvertime(query) {
		const response = await request.get('/app/dashboard/overtime', query);
		return response;
	},
	async getByChannel(query) {
		const response = await request.get('/app/dashboard/by-channel', query);
		return response;
	},
	async getByCategory(query) {
		const response = await request.get('/app/dashboard/by-category', query);
		return response;
	},
	async getByPaymentMethod(query) {
		const response = await request.get('/app/dashboard/by-payment-method', query);
		return response;
	}
};
